/*global google*/
import 'react-loading-skeleton/dist/skeleton.css';

import React, {useContext, useState, useEffect, useRef} from 'react';
import {Button, Form, InputGroup, Col, Row, Container, Modal, ProgressBar} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faStore,
    faChevronDown,
    faChevronUp,
    faCartShopping,
    faArrowLeft,
    faBagShopping,
    faCalendar,
    faTruck,
    faMapMarkerAlt,
    faChevronRight,
    faQuoteLeft
} from '@fortawesome/free-solid-svg-icons';
import EditCartModal from '../elements/EditCartModal';
import {checkCouponThunk, clearCoupon} from '../store/coupons';
import {useDispatch, useSelector} from 'react-redux';
import EditFreeItemModal from '../elements/EditFreeItemModal';
import {getFreeItemsThunk} from '../store/freeitems';
import {placeOrderThunkPayInStore} from '../store/order';
import {useNavigate} from 'react-router-dom';
import CheckoutApp from '../elements/StripeCheckoutApp';
import loadingJson from '../asset/JSON/loading.json';
import Lottie from 'react-lottie-player';
import Context from '../Context';
import Header from '../elements/Header';
import Swal from 'sweetalert2';
import {clearCheckoutSession, fetchFeesThunk} from '../store/stripe';
import {buyPointsThunk, getRewardsThunk} from '../store/rewards';
import AddressModal from '../elements/AddressModal';
import {RewardModal} from '../elements/RewardModal';
import Skeleton from 'react-loading-skeleton';
import {FaArrowRight, FaLongArrowAltRight} from 'react-icons/fa';
import EditRewardItemModal from '../elements/EditRewardItemModal';
import {getItemAttributeNameById, validateCartItemsByCategoryTime} from '../functions';
import {getHoursThunk} from '../store/restaurant';
import "./checkout.css"

const Checkout = ({fee}) => {
    const navigate = useNavigate()
    const {language, restaurantId, changedCart, setChangedCart} = useContext(Context);
    const [cart, setCart] = useState([]);
    const [freeItem, setFreeItem] = useState([]);
    const [rewardItem, setRewardItem] = useState([]);
    const [promoCode, setPromoCode] = useState('');
    const [orderMethod, setOrderMethod] = useState('pickup'); // pickup or delivery
    const [cartOpen, setCartOpen] = useState(true); // State to toggle cart items
    const [editCartModal, setEditCartModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [currentUserAddress, setCurrentUserAddress] = useState(null);
    const [addressVerified, setAddressVerified] = useState(false);
    const [addressErrors, setAddressErrors] = useState('');
    const [needDelivery, setNeedDelivery] = useState(false);
    const [checkingCoupon, setCheckingCoupon] = useState(false);
    const [couponError, setCouponError] = useState('');
    const [tip, setTip] = useState(10);
    const [customTip, setCustomTip] = useState(0);
    const [showTipModal, setShowTipModal] = useState(false);
    const [showPaymentModal, setShowPaymentModal] = useState(false); // State for payment modal
    const dispatch = useDispatch();
    const checkCoupon = useSelector(state => state.coupons.coupon);
    const [editFreeItem, setEditFreeItem] = useState(false);
    const freeItems = useSelector((state) => state.freeItems.freeitems);
    const [paymentOption, setPaymentOption] = useState('online');
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [error, setError] = useState('');
    const [email, setEmail] = useState('')
    const [payinStoreLoading, setPayinStoreLoading] = useState(false);  // State for loading spinner
    const [paymentSubmitLoading, setPaymentSubmitLoading] = useState(false);  // State for loading spinner
    const [needSchdule, setNeedSchdule] = useState(false)
    const [timeSlots, setTimeSlots] = useState([]);
    const [selectedTime, setSelectedTime] = useState(null);
    const [timeModal, setTimeModal] = useState(false)
    const [rewardPoints, setRewardPoints] = useState(0);
    const [loading, setLoading] = useState(false);
    const [isRewardModalOpen, setIsRewardModalOpen] = useState(false);
    const [editRewardItem, setEditRewardItem] = useState(false);
    const [todayLabel, setTodayLabel] = useState("");
    const [showAddressModal, setShowAddressModal] = useState(false)
    const [distanceText, setDistanceText] = useState('');
    const [addressInput, setAddressInput] = useState('');
    const [aptNumber, setAptNumber] = useState('');
    const [deliveryInstructions, setDeliveryInstructions] = useState('');
    // const hasCoupon = useSelector((state) => state.coupons.hasCoupon);
    const calculatedFees = useSelector(state => state.stripe?.feeBreakdown)
    const [feeLoading, setFeesLoading] = useState(true);
    const [acutalTip, setAcutalTip] = useState(0)
    const [errorStatus, setErrorStatus] = useState(null)
    const nameRef = useRef(null);
    const phoneRef = useRef(null);
    const hours = useSelector(state => state.restaurants.hours)
    const restaurant = useSelector(state => state.restaurants.restaurant);

    useEffect(() => {
        let loadingTimeout;

        const fetchWithDelay = async () => {
            setFeesLoading(true); // Start loading state

            loadingTimeout = setTimeout(() => {
                dispatch(fetchFeesThunk(tip, acutalTip, restaurantId, cart, checkCoupon, currentUserAddress, needDelivery))
                    .finally(() => setFeesLoading(false)); // Stop loading after server fetch
            }, 300); // 0.3secibd
        };

        fetchWithDelay();

        return () => {
            clearTimeout(loadingTimeout); // Clean up timeout
        };
    }, [dispatch, tip, acutalTip, restaurantId, cart, checkCoupon.coupon_id, currentUserAddress, needDelivery]);


    useEffect(() => {
        const generateTimeSlots = () => {
            const slots = [];
            const now = new Date();
            now.setSeconds(0, 0);

            const currentDay = now.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6

            const openingHours = {
                0: {open: '09:30', close: '21:30'}, // Sunday
                1: {open: '11:00', close: '21:30'}, // Monday
                2: {open: '11:00', close: '21:30'}, // Tuesday
                3: {open: '11:00', close: '21:30'}, // Wednesday
                4: {open: '11:00', close: '21:30'}, // Thursday
                5: {open: '09:30', close: '22:00'}, // Friday
                6: {open: '09:30', close: '22:00'}, // Saturday
            };

            const {open, close} = openingHours[currentDay];

            const [openHour, openMinute] = open.split(':').map(Number);
            const [closeHour, closeMinute] = close.split(':').map(Number);

            const startTime = new Date();
            startTime.setHours(openHour, openMinute, 0, 0);

            const endTime = new Date();
            endTime.setHours(closeHour, closeMinute, 0, 0);

            // Start from current time + 1 hour, or opening time (whichever is later)
            let current = new Date(now.getTime() + 60 * 60 * 1000);
            if (current < startTime) current = new Date(startTime);

            // Round up to the next 5-minute interval
            const minutes = current.getMinutes();
            const roundedMinutes = Math.ceil(minutes / 5) * 5;
            current.setMinutes(roundedMinutes);

            // Generate time slots
            while (current <= endTime) {
                const formatted = current.toLocaleString('en-US', {
                    hour: 'numeric', minute: '2-digit', hour12: true, month: 'numeric', day: 'numeric', year: 'numeric'
                });
                slots.push(formatted);
                current.setMinutes(current.getMinutes() + 5);
            }

            setTimeSlots(slots);
        };

        generateTimeSlots();
    }, []);


    const handleTimeSelect = (time) => {
        setSelectedTime(time);
    };
    useEffect(() => {
        const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
        const storedFreeItem = JSON.parse(localStorage.getItem('freeItem')) || [];
        const storedRewardItem = JSON.parse(localStorage.getItem('rewardItem')) || [];

        setCart(storedCart);
        setFreeItem(storedFreeItem);
        setRewardItem(storedRewardItem);
    }, []);

    useEffect(() => {
        const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
        const storedFreeItem = JSON.parse(localStorage.getItem('freeItem')) || [];
        const storedRewardItem = JSON.parse(localStorage.getItem('rewardItem')) || [];

        setCart(storedCart);
        setFreeItem(storedFreeItem);
        setRewardItem(storedRewardItem);
    }, [changedCart]);


    useEffect(() => {
        if (needDelivery) {
            setTip(15);
        } else if (fee?.tip_options?.length > 0) {
            const sortedTips = [...fee.tip_options].sort((a, b) => a - b);
            setTip(sortedTips[0]); // smallest tip option
        } else {
            setTip(10); // fallback if no tip_options in fee and no delivery
        }
    }, [fee, needDelivery]);


    useEffect(() => {
        if (restaurantId) {
            dispatch(getFreeItemsThunk(restaurantId));
            // dispatch(checkRestaurantCouponThunk(restaurantId))
            dispatch(getHoursThunk(restaurantId))

        }
    }, [restaurantId, dispatch]);


    function toTitleCase(str) {
        return str
            ?.split(" ")
            ?.map(word => {
                // Capitalize first letter only if it's alphabetic
                if (/^[a-z]/i?.test(word)) {
                    return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase();
                }
                return word;
            })
            ?.join(" ");
    }

    const restaurantAddress = `815 E 78th St, Minneapolis, MN 55420`;

    useEffect(() => {
        if (restaurantAddress) {
            if (needDelivery) {
                geocodeRestaurantAddressAndLoadMap();
            } else {
                geocodeRestaurantAddressAndLoadMap();
            }
        }
    }, [needDelivery, restaurantAddress]);

    useEffect(() => {
        if (showAddressModal) {
            handleScriptLoad();
        }
    }, [showAddressModal]);


    let autocomplete;
    const handleScriptLoad = () => {
        autocomplete = new google.maps.places.Autocomplete(document.getElementById("autocomplete"), {types: ["geocode"]});
        autocomplete.addListener("place_changed", handlePlaceSelect);
    };

    async function handlePlaceSelect() {
        let place = autocomplete.getPlace();

        if (!place.geometry) {
            setAddressErrors("Please enter a valid address");
            // Clear input to force user reselect or type a valid address
            setAddressInput("");
            return;
        }

        const isWithinDistance = await checkDistance(place.formatted_address);

        if (isWithinDistance) {
            setCurrentUserAddress(place.formatted_address);
            setAddressInput(place.formatted_address);
            setAddressVerified(true);
            setAddressErrors("");
        } else {
            // Show error message but DO NOT reset input value!
            setAddressErrors(`Sorry, we can only deliver up to ${(fee?.max_delivery_range || 5)} miles.`);
            setCurrentUserAddress(place.formatted_address);
            setAddressInput(place.formatted_address);
            setAddressVerified(false);
            // Important: Do NOT update setAddressInput here, so full address stays visible
        }
    }


    const checkDistance = async (userAddress) => {
        const service = new google.maps.DistanceMatrixService();
        return new Promise((resolve) => {
            service.getDistanceMatrix({
                origins: [userAddress],
                destinations: [restaurantAddress],
                travelMode: google.maps.TravelMode.DRIVING,
                unitSystem: google.maps.UnitSystem.IMPERIAL,
            }, (response, status) => {
                if (status === 'OK') {
                    const element = response.rows[0].elements[0];

                    if (element.status === 'OK') {
                        const distanceInMiles = element.distance.value * 0.000621371;

                        setDistanceText(Number(distanceInMiles).toFixed(2));

                        if (distanceInMiles <= (+fee?.max_delivery_range || 5)) {
                            setAddressErrors("");
                            setAddressVerified(true);
                            resolve(true);
                        } else {
                            setAddressErrors(`Sorry, we cannot deliver to places more than ${(fee?.max_delivery_range || 5)} miles away.`);
                            setAddressVerified(false);
                            resolve(false);
                        }
                    } else {
                        setAddressErrors("Unable to calculate driving distance. Please try again later.");
                        setAddressVerified(false);
                        setDistanceText(null);
                        resolve(false);
                    }
                } else {
                    setAddressErrors("Error retrieving distance matrix. Please try again later.");
                    setAddressVerified(false);
                    setDistanceText(null);
                    resolve(false);
                }
            });
        });
    };


    const geocodeRestaurantAddressAndLoadMap = () => {
        if (!restaurantAddress) return; // prevent unnecessary geocoding attempt

        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({address: restaurantAddress}, (results, status) => {
            if (status === "OK") {
                const storeLatLng = results[0].geometry.location;
                renderMap(storeLatLng);
            } else {
                console.error("Failed to geocode restaurant address");
            }
        });
    };

    const renderMap = (storeLatLng) => {
        const mapOptions = {
            center: storeLatLng, zoom: needDelivery ? 10 : 16, mapTypeId: google.maps.MapTypeId.ROADMAP,
        };
        const map = new google.maps.Map(document.getElementById("gmp-map"), mapOptions);

        new google.maps.Marker({
            position: storeLatLng, title: "Restaurant Location", map: map,
        });

        if (needDelivery) {
            new google.maps.Circle({
                strokeColor: "#FF0000",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#FF0000",
                fillOpacity: 0.35,
                map: map,
                center: storeLatLng,
                radius: 1609.34 * 4, // 4 miles in meters
            });
        }
    };


    //handle coupon
    const checkCurrentCoupon = async (e) => {
        e.preventDefault();
        setCheckingCoupon(true);
        setCouponError('');
        try {
            await dispatch(checkCouponThunk(promoCode));
        } catch (error) {
            setCheckingCoupon(false);
        } finally {
            setCheckingCoupon(false);
        }
    };

    const handleRemoveCoupon = () => {
        setPromoCode('');
        setCouponError('');
        dispatch(clearCoupon(''));
    };

    const handleEditCartModal = (item) => {
        setSelectedItem(item);
        setEditCartModal(true);
    };


    const calculateDiscount = () => {
        const subtotal = parseFloat(calculatedFees?.subtotal);
        let discount = 0;

        if (checkCoupon && subtotal >= parseFloat(checkCoupon.min_require)) {
            if (checkCoupon.discount_type === 'Percentage') {
                discount = (subtotal * (parseFloat(checkCoupon.discount) / 100)).toFixed(2);
            } else {
                discount = parseFloat(checkCoupon.discount);
            }
        }

        return discount;
    };


    useEffect(() => {
        if (checkCoupon?.min_require && parseFloat(calculatedFees?.subtotal) < parseFloat(checkCoupon.min_require)) {
            setCouponError('Minimum order amount of $' + checkCoupon.min_require + ' is required to use this coupon.');
        }
    }, [checkCoupon, calculatedFees?.subtotal])

    const handleTipSelect = (percentage) => {
        setTip(percentage)
        setCustomTip(0)
    };

    const handleCustomTip = () => {
        setTip(0);
        setCustomTip(acutalTip)
        setShowTipModal(true);
    };

    const incrementTip = () => setCustomTip(prevTip => +prevTip + 1);
    const decrementTip = () => setCustomTip(prevTip => +Math.max(0, prevTip - 1));


    const handleCustomTipChange = (e) => {
        if (/^\d*$/.test(e.target.value)) { // Allow only digits
            setCustomTip(Number(e.target.value));
        }
        setTip(0); // Reset tip percentage
    };


    const handleEditFreeItem = (item) => {
        setSelectedItem(item);
        setEditFreeItem(true);
    };

    const handleEditRewardItem = (item) => {
        setSelectedItem(item);
        setEditRewardItem(true);
    };

    const needAmountReached = () => {
        // Iterate through freeItems array
        const freeItemed = JSON.parse(localStorage.getItem('freeItem'));


        if (freeItem?.Item) {
            for (const freeItem of freeItems) {
                // Find the matching ReedemableItem based on item
                for (const item of freeItem.ReedemableItems) {
                    if (item?.Item?.id === freeItemed?.Item?.id) {
                        return +freeItem.need_amount <= +calculatedFees?.subtotal;
                    }
                }
            }
        } else {
            return true;
        }
    };

    const isRestaurantOpen = () => {
        if (!hours?.time_zone) return false;

        const timeZoneMap = {
            "EST": "America/New_York", "CST": "America/Chicago", "MST": "America/Denver", "PST": "America/Los_Angeles",
        };

        const timeZone = timeZoneMap[hours.time_zone] || "America/New_York";
        const now = new Date();

        const currentDay = now.toLocaleString("en-US", {timeZone, weekday: "long"}).toLowerCase();
        const todayHours = hours[currentDay];

        if (!todayHours || todayHours.toLowerCase() === "closed") return false;

        const [openClose, breakTime] = todayHours.split("|");
        const [openStr, closeStr] = openClose.split("-");
        const [breakStartStr, breakEndStr] = breakTime?.split("-") || [];

        const getMinutes = (timeStr) => {
            const [h, m] = timeStr.split(":").map(Number);
            return h * 60 + m;
        };

        const currentTime = now.toLocaleTimeString("en-US", {
            timeZone, hour12: false, hour: "2-digit", minute: "2-digit"
        });
        const nowMinutes = getMinutes(currentTime);
        const openMinutes = getMinutes(openStr);
        const closeMinutes = getMinutes(closeStr);
        if (nowMinutes < openMinutes || nowMinutes > closeMinutes) return false;

        if (breakStartStr && breakEndStr) {
            const breakStartMinutes = getMinutes(breakStartStr);
            const breakEndMinutes = getMinutes(breakEndStr);
            if (nowMinutes >= breakStartMinutes && nowMinutes < breakEndMinutes) return false;
        }

        return true;
    };

    const showRestaurantTimeError = () => {
        const timeZone = hours?.time_zone || "EST";
        const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

        const formattedHours = days.map(day => {
            const key = day.toLowerCase();
            const raw = hours?.[key];

            if (!raw || raw.toLowerCase() === "closed") return `${day}: Closed`;

            const [main, breakStr] = raw.split("|");
            const display = `${main}${breakStr ? ` (Break: ${breakStr})` : ""}`;
            return `${day}: ${display}`;
        }).join("\n");

        Swal.fire({
            icon: 'error',
            title: 'Please come back later.',
            html: `<pre style="text-align:left">${formattedHours}</pre><br/><b>Time Zone:</b> ${timeZone}`
        });
    };


//proceed to payment button
    const handlePlaceOrder = () => {
        const isValid = validateCartItemsByCategoryTime(cart, restaurant.Categories, hours);
        if (!isValid) return;

        if (!isRestaurantOpen()) {
            showRestaurantTimeError();
            return;
        }


        if (!fee?.tax || fee?.tax <= 0) {
            Swal.fire({
                icon: 'error', title: 'Please Add Tax(REQUIRED!) to your restaurant, other fees are optional. '
            })
            return
        }


        if (!name && !phone) {
            setErrorStatus(1);
            setError('Please enter your name and phone number.');
            nameRef.current?.scrollIntoView({behavior: 'smooth', block: 'center'});
            return;
        }

        if (!name) {
            setErrorStatus(2);
            setError('Please enter your name.');
            nameRef.current?.scrollIntoView({behavior: 'smooth', block: 'center'});
            return;
        }

        if (!phone) {
            setErrorStatus(3);
            setError('Please enter your phone number.');
            phoneRef.current?.scrollIntoView({behavior: 'smooth', block: 'center'});
            return;
        }

        if (!/^\d{10}$/.test(phone.replace(/\D/g, ''))) {
            setErrorStatus(4);
            setError('Please enter a valid phone number.');
            phoneRef.current?.scrollIntoView({behavior: 'smooth', block: 'center'});
            return;
        }


        setErrorStatus(null);
        setError('');

        setShowPaymentModal(true);
    };


    const handlePaymentMethodChange = (selectedOption) => {
        setPaymentOption(selectedOption);
    }


    const handlePayInStore = async () => {
        setPayinStoreLoading(true);
        try {
            await dispatch(placeOrderThunkPayInStore(restaurantId, paymentOption, name, phone, tip, customTip, currentUserAddress || null, cart, checkCoupon, freeItem?.Item ? freeItem : null, null, selectedTime ? selectedTime : 'ASAP', rewardItem?.Item ? rewardItem : null, email, aptNumber, deliveryInstructions))
                .then(() => {

                    dispatch(buyPointsThunk(restaurantId, phone, name, calculatedFees?.subtotal, email));

                    setChangedCart(!changedCart);
                    setPayinStoreLoading(false);

                    navigate("/order-processing");
                })
        } catch (error) {
            setPayinStoreLoading(false);
            console.error('An error occurred:', error);
        }
    }


    // Function to handle raw phone value and store it
    const handlePhoneChange = (e) => {
        const input = e.target.value.replace(/\D/g, ''); // Remove non-digit characters
        if (input.length <= 10) {
            setPhone(input); // Store only raw 10-digit phone number
        }

        if (input === '') {
            setErrorStatus(null);
        }

        // Automatically trigger reward points check if input is exactly 10 digits
        if (input.length === 10) {
            checkRewardPoints(input);
        }
    };

    // Function to format phone number for display
    const formatPhoneNumber = (phone) => {
        if (phone.length > 6) {
            return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
        } else if (phone.length > 3) {
            return `(${phone.slice(0, 3)}) ${phone.slice(3)}`;
        } else if (phone.length > 0) {
            return `(${phone}`;
        }
        return '';
    };

    const checkRewardPoints = async (phoneNumber) => {
        setLoading(true);
        try {
            const points = await dispatch(getRewardsThunk(restaurantId, phoneNumber));
            if (points) {
                setRewardPoints(points);
            } else {
                setRewardPoints(0);
            }
        } catch (error) {
            console.error('Error fetching reward points:', error);
        } finally {
            setLoading(false);
        }
    };


    const handleSelectSavedAddress = (addr) => {
        setAddressInput(addr);
        setCurrentUserAddress(addr);
        checkDistance(addr)
    };
    // Save address to localStorage helper
    const handleSaveAddress = (a, d) => {
        setAddressVerified(true);

        setAptNumber(a)
        setDeliveryInstructions(d)

        const key = `savedAddresses_${restaurantId}`;
        // Get existing saved addresses from localStorage or start with empty array
        const saved = localStorage.getItem(key);
        const savedAddresses = saved ? JSON.parse(saved) : [];

        // Add new address only if it doesn't already exist
        if (!savedAddresses.includes(addressInput)) {
            savedAddresses.unshift(addressInput);
            // Keep only the 5 most recent addresses
            localStorage.setItem(key, JSON.stringify(savedAddresses.slice(0, 5)));
        }

        // Close the modal after saving
        setShowAddressModal(false);
    };

    const handleModalClose = () => {
        dispatch(clearCheckoutSession());
        setShowPaymentModal(false);
    };

    return (<>
            <div className='bg-white checkout-content' style={{marginTop: '80px'}}>
                {/* <Header /> */}
                <Container className="checkout-page bg-gray">
                    <Row>
                        <Col lg={7} md={12} sm={12}>
                            <div className="section pickup-details">

                                <div className='d-flex row align-items-center justify-content-center'>
                                    <div className="text-center mb-0">
                                        <h5 className="fw-bold fs-5">Checkout</h5>
                                    </div>

                                    <div className="d-flex flex-column align-items-center gap-2">
                                        <button
                                            type="button"
                                            className={`pickup-option   w-100 ${orderMethod === 'pickup' ? 'active' : ''}`}
                                            onClick={() => {
                                                setOrderMethod('pickup');
                                                setNeedDelivery(false);
                                                setAddressErrors(null);
                                                setAddressInput(null);
                                                setCurrentUserAddress(null);
                                                setAddressVerified(false);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faStore} className="me-2"/>
                                            Pickup {orderMethod === 'pickup' &&
                                            <span className="badge bg-light text-dark">Selected</span>}
                                        </button>

                                        <button
                                            type="button"
                                            className={`pickup-option  w-100 ${orderMethod === 'delivery' ? 'active' : ''}`}
                                            onClick={() => {
                                                setOrderMethod('delivery');
                                                setNeedDelivery(true);
                                                setNeedSchdule(false);
                                                setSelectedTime(false);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faTruck} className="me-2"/>
                                            Delivery {orderMethod === 'delivery' &&
                                            <span className="badge bg-light text-dark">Selected</span>}
                                        </button>
                                    </div>


                                    {orderMethod === 'delivery' && (<div className="rounded-3 text-start mt-3">
                                            <div className="rounded-3 text-start">
                                                {/* Section: Delivery Address */}
                                                <h5 className="fw-semibold fs-6 mb-3 d-flex align-items-center gap-2">
                                                    <span>Delivery Address</span>
                                                </h5>

                                                <div
                                                    className="d-flex align-items-center justify-content-between p-3 border rounded cursor-pointer transition-shadow"
                                                    onClick={() => setShowAddressModal(true)}
                                                    style={{borderColor: '#dee2e6'}}
                                                >
                                                    <div className="d-flex align-items-center me-3">
                                                        <div
                                                            className="d-flex align-items-center justify-content-center bg-light rounded-circle"
                                                            style={{width: '40px', height: '40px'}}
                                                        >
                                                            <FontAwesomeIcon icon={faMapMarkerAlt}
                                                                             className="text-dark fs-6"/>
                                                        </div>

                                                        <div className="ms-3">
                                                            {currentUserAddress ? (<div>
                                                                    <p className="mb-0 fw-bold small">{currentUserAddress}</p>
                                                                    {(aptNumber || deliveryInstructions) && (
                                                                        <p className="mb-0 text-muted small">
                                                                            {[aptNumber, deliveryInstructions].filter(Boolean).join(', ')}
                                                                        </p>)}
                                                                </div>) : (
                                                                <p className="mb-0 fw-semibold small text-decoration-underline">
                                                                    Add delivery address
                                                                </p>)}
                                                        </div>
                                                    </div>

                                                    <FontAwesomeIcon icon={faChevronRight} className="text-dark fs-6"/>
                                                </div>
                                            </div>

                                            <AddressModal
                                                showAddressModal={showAddressModal}
                                                setShowAddressModal={setShowAddressModal}
                                                onSaveAddress={handleSaveAddress}
                                                addressInput={addressInput}
                                                setAddressInput={setAddressInput}
                                                addressVerified={addressVerified}
                                                addressErrors={addressErrors}
                                                distanceText={distanceText}
                                                restaurantId={restaurantId}
                                                handleSelectSavedAddress={handleSelectSavedAddress}
                                            />
                                        </div>)}

                                    <div className="mt-3">
                                        <h5 class="fw-semibold fs-6 mb-3">{needDelivery ? 'Delivery' : 'Pickup'} Options</h5>


                                        <div
                                            className={`d-flex align-items-center cursor-pointer justify-content-between ${!needSchdule ? 'bg-co' : 'bg-co-un'}`}
                                            style={{
                                                padding: '12px',
                                                borderRadius: '15px',
                                                marginBottom: '1rem',
                                                border: '1px solid gray'

                                            }}
                                            onClick={() => {
                                                setNeedSchdule(false)
                                                setSelectedTime(null)
                                            }}
                                        >
                                            <div className="d-flex align-items-center ">
                                                <FontAwesomeIcon icon={faBagShopping} size="2x"
                                                                 style={{marginRight: '1rem'}}/>
                                                <div>
                                                    {needDelivery ? (<p style={{margin: 0, fontWeight: '500',}}>
                                                            Standard 30-45 min (ASAP)

                                                        </p>) : (<p style={{margin: 0, fontWeight: '500',}}>
                                                        Standard 10-20min (ASAP)

                                                    </p>)}
                                                </div>
                                            </div>
                                        </div>


                                        {needDelivery ? <></> : (<div
                                                className={`d-flex align-items-center justify-content-between cursor-pointer ${needSchdule ? 'bg-co' : 'bg-co-un'}`}
                                                style={{
                                                    padding: '12px', borderRadius: '15px', border: '1px solid gray'

                                                }}
                                                onClick={() => {
                                                    setNeedSchdule(true)
                                                    setTimeModal(true)
                                                }}

                                            >
                                                <div className="d-flex align-items-center">
                                                    <FontAwesomeIcon icon={faCalendar} size="2x"
                                                                     style={{marginRight: '1rem'}}/>
                                                    <div>
                                                        <p style={{
                                                            margin: 0, fontWeight: '500'
                                                        }}>{selectedTime ? 'Schedule For: ' + selectedTime : 'Schedule Pickup Time'}</p>

                                                    </div>
                                                </div>
                                            </div>)}
                                    </div>
                                </div>

                                <div className="d-none d-md-block">
                                    <div id="gmp-map" className="gmp-map"></div>

                                    <div className="mt-3">
                                        <div className="d-flex align-items-center justify-content-center mb-3">
                                            <div
                                                className="rounded-circle bg-success me-2"
                                                style={{
                                                    width: '12px', height: '12px', animation: 'pulse 1.5s infinite'
                                                }}
                                            ></div>
                                            <span className="text-dark fw-semibold small">Restaurant Location</span>
                                        </div>
                                        <p className="text-dark fw-semibold text-center small">
                                            2960 Shallowford Rd # 311, Marietta, GA 30066 </p>
                                    </div>
                                </div>


                            </div>


                        </Col>
                        <Col lg={5} md={12} sm={12}>
                            <div className="section">
                                <div
                                    className="d-flex justify-content-between align-items-center"
                                    style={{
                                        borderBottom: '2px solid #dee2e6',
                                        paddingBottom: '0.5rem',
                                        marginBottom: '1rem',
                                        cursor: 'pointer',
                                        userSelect: 'none',
                                        flexWrap: 'nowrap'
                                    }}
                                    onClick={() => setCartOpen(!cartOpen)}
                                >
                                    <h5
                                        className="fw-semibold mb-0 d-flex align-items-center gap-2"
                                        style={{
                                            fontSize: '1rem', // base size
                                            margin: 0,
                                        }}
                                    >
    <span className="text-truncate" style={{maxWidth: '100%'}}>
      Cart summary ({cart.length} item{cart.length !== 1 ? 's' : ''})
    </span>
                                        <FontAwesomeIcon icon={cartOpen ? faChevronUp : faChevronDown}/>
                                    </h5>

                                    {cart.length > 0 && (<button
                                            onClick={(e) => {
                                                e.stopPropagation(); // prevent toggle
                                                localStorage.removeItem('cart');
                                                localStorage.removeItem('freeItem');
                                                setChangedCart(!changedCart);
                                            }}
                                            className="btn btn-outline-danger ms-3"
                                            style={{
                                                borderRadius: '25px',
                                                padding: '0.25rem 0.75rem',
                                                fontSize: '0.75rem',
                                                fontWeight: 600,
                                                minWidth: '80px',
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            Clear Cart
                                        </button>)}
                                </div>


                                {cartOpen && (<>


                                        <div>

                                            {rewardItem?.Item && (<div
                                                    onClick={() => handleEditRewardItem({
                                                        id: rewardItem?.Item.id,
                                                        name: rewardItem?.Item?.name,
                                                        price: rewardItem?.Item.price,
                                                        quantity: rewardItem?.quantity,
                                                        special_instructions: rewardItem?.special_instructions,
                                                        image_url: rewardItem?.Item?.image_url,
                                                        Restaurant_Item_Attributes: rewardItem?.Item?.Restaurant_Item_Attributes,
                                                        options: rewardItem?.options,
                                                    })}
                                                    className="cart-item d-flex align-items-start mb-3"
                                                >
                                                    <img
                                                        src={rewardItem.Item.image_url || 'https://theme-assets.getbento.com/sensei/3914814.sensei/assets/images/catering-item-placeholder-704x520.png'}
                                                        alt={rewardItem.Item.name}
                                                        className="cart-item-image me-3"
                                                    />
                                                    <div className="cart-item-details flex-grow-1">
                                                        <p className='item-name mb-1'>{language === 'en' ? rewardItem?.Item?.name : rewardItem?.Item?.chinese_name}</p>
                                                        {rewardItem?.options?.map((attribute) => (
                                                            <p className="item-attribute small m-0" key={attribute.id}>
                                                                {getItemAttributeNameById(attribute.id, rewardItem.Item)} {attribute?.priceModifier > 0 ? `+ $${attribute.priceModifier}` : null}
                                                            </p>))}
                                                        {rewardItem?.special_instructions && (
                                                            <p className="item-instructions small m-0">
                                                                <strong>**</strong> {rewardItem?.special_instructions}
                                                            </p>)}
                                                    </div>
                                                    <div
                                                        className="cart-item-quantity d-flex align-items-center justify-content-center">
                                                        <span className="item-quantity">1</span>
                                                    </div>
                                                    <p className="item-price ms-3">Reward</p>

                                                </div>

                                            )}

                                            {freeItem?.Item && (<div
                                                    onClick={() => handleEditFreeItem({
                                                        id: freeItem?.Item.id,
                                                        name: freeItem?.Item?.name,
                                                        price: freeItem?.Item.price,
                                                        quantity: freeItem?.quantity,
                                                        special_instructions: freeItem?.special_instructions,
                                                        image_url: freeItem?.Item?.image_url,
                                                        Restaurant_Item_Attributes: freeItem?.Item?.Restaurant_Item_Attributes,
                                                        options: freeItem?.options,
                                                    })}
                                                    className="cart-item d-flex align-items-start mb-3"
                                                >
                                                    <img
                                                        src={freeItem.Item.image_url || 'https://theme-assets.getbento.com/sensei/3914814.sensei/assets/images/catering-item-placeholder-704x520.png'}
                                                        alt={freeItem.Item.name}
                                                        className="cart-item-image me-3"
                                                    />
                                                    <div className="cart-item-details flex-grow-1">
                                                        <p className='item-name mb-1'>{language === 'en' ? freeItem?.Item?.name : freeItem?.Item?.chinese_name}</p>
                                                        {freeItem?.options?.map((attribute) => (
                                                            <p className="item-attribute small m-0" key={attribute.id}>
                                                                {getItemAttributeNameById(attribute.id, freeItem.Item)} {attribute?.priceModifier > 0 ? `+ $${attribute.priceModifier}` : null}
                                                            </p>))}
                                                        {freeItem?.special_instructions && (
                                                            <p className="item-instructions small m-0">
                                                                <strong>**</strong> {freeItem?.special_instructions}
                                                            </p>)}
                                                    </div>
                                                    <div
                                                        className="cart-item-quantity d-flex align-items-center justify-content-center">
                                                        <span className="item-quantity">1</span>
                                                    </div>
                                                    <p className="item-price ms-3">Free</p>


                                                </div>

                                            )}
                                        </div>

                                        <div>
                                            {cart.map((item, index) => (
                                                <div key={index} className="cart-item d-flex align-items-start mb-3"
                                                     onClick={() => handleEditCartModal({
                                                         id: item?.Item.id,
                                                         name: item?.Item?.name,
                                                         price: item?.Item.price,
                                                         special_instructions: item?.special_instructions,
                                                         image_url: item?.Item?.image_url,
                                                         Restaurant_Item_Attributes: item?.Item?.Restaurant_Item_Attributes,
                                                         options: item?.options,
                                                         index: index,
                                                         category_id: item.Item.category_id,
                                                         chinese_name: item.chinese_name

                                                     })}
                                                >
                                                    <img
                                                        src={item.Item.image_url || 'https://theme-assets.getbento.com/sensei/3914814.sensei/assets/images/catering-item-placeholder-704x520.png'}
                                                        alt={item.Item.name}
                                                        className="cart-item-image me-3"
                                                    />
                                                    <div className="cart-item-details flex-grow-1">
                                                        <p className="item-name mb-1">{language === 'en' ? item?.Item?.name : item?.Item?.chinese_name}</p>
                                                        {item?.options?.map((attribute, idx) => (
                                                            <p className="item-attribute small m-0" key={idx}>
                                                                {getItemAttributeNameById(attribute.id, item.Item)} {attribute?.priceModifier > 0 ? `+ $${attribute.priceModifier}` : null}
                                                            </p>))}
                                                        {item?.special_instructions && (
                                                            <p className="item-instructions small m-0">
                                                                <strong>**</strong> {item?.special_instructions}
                                                            </p>)}
                                                    </div>
                                                    <div
                                                        className="cart-item-quantity d-flex align-items-center justify-content-center">
                                                        <span className="item-quantity">{item.quantity}</span>
                                                    </div>
                                                    <p className="item-price ms-3">${item.price}</p>
                                                </div>))}
                                        </div>
                                    </>)}
                                <div style={{textAlign: 'center'}}>
                                    <div
                                        style={{
                                            display: 'inline-block',
                                            padding: '0.5rem 1rem',
                                            borderRadius: '9999px',
                                            fontWeight: '600',
                                            fontSize: '0.95rem',
                                            cursor: 'pointer',
                                            userSelect: 'none',
                                            border: '1px solid #d1d5db',
                                            transition: 'all 0.2s ease',
                                            textAlign: 'center',
                                            color: 'black'

                                        }}
                                        onClick={() => navigate('/order')}
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={e => {
                                            if (e.key === 'Enter' || e.key === ' ') navigate('/order');
                                        }}
                                        onMouseEnter={e => {
                                            e.currentTarget.style.backgroundColor = '#e5e7eb';
                                        }}
                                        onMouseLeave={e => {
                                            e.currentTarget.style.backgroundColor = 'white';
                                        }}
                                    >
                                        + Add More
                                    </div>
                                </div>


                            </div>
                            {/* {hasCoupon && ( */}
                            <div className="section promotion">
                                <InputGroup>
                                    <Form.Control
                                        type="text"
                                        placeholder="Add promo code"
                                        value={promoCode}
                                        onChange={(e) => {
                                            const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
                                            setPromoCode(input);

                                            // Clear error if input is empty
                                            if (input === '') {
                                                setCouponError(null);
                                                dispatch(clearCoupon())
                                            }
                                        }}
                                    />


                                    <Button variant="outline-primary btn" onClick={(e) => checkCurrentCoupon(e)}>
                                        {checkingCoupon ?
                                            <span className="spinner-border spinner-border-sm"></span> : 'Apply'}
                                    </Button>
                                </InputGroup>

                                {checkCoupon && parseFloat(calculatedFees?.subtotal) >= parseFloat(checkCoupon.min_require) && (
                                    <div className="mt-2 text-center text-success">
                                        <p>Coupon applied! Discount: ${calculateDiscount()}</p>
                                        <Button variant="link" onClick={handleRemoveCoupon}>Remove coupon</Button>
                                    </div>)}

                                {checkCoupon && parseFloat(calculatedFees?.subtotal) < parseFloat(checkCoupon.min_require) && (
                                    <div className="mt-2 text-center text-danger bg-light p-2 rounded fw-semibold">
                                        Minimum order amount of ${checkCoupon.min_require} is required to use this
                                        coupon.
                                    </div>)}

                                {checkCoupon && checkCoupon.message && (
                                    <div className="mt-2 text-center text-danger bg-light p-2 rounded fw-semibold">
                                        {checkCoupon.message}
                                    </div>)}

                                {!checkCoupon && couponError && (
                                    <div className="mt-2 text-center text-danger bg-light p-2 rounded fw-semibold">
                                        {couponError || 'Invalid coupon code.'}
                                    </div>)}
                            </div>

                            {/* )} */}

                            <div className="section">
                                <h5
                                    style={{
                                        fontWeight: 600,      // medium-bold
                                        fontSize: '1rem',     // slightly smaller than 1.1rem
                                        marginBottom: '0.75rem', color: '#212529',     // default Bootstrap text color (dark)
                                    }}
                                >
                                    Customer Info <span className="text-danger">*</span>
                                </h5>
                                <span
                                    style={{
                                        fontSize: '0.875rem',      // smaller font for hint
                                        color: '#6c757d',          // Bootstrap's text-secondary gray
                                        display: 'block',          // so it sits nicely on its own line
                                        marginTop: '0.25rem',      // a little spacing above
                                    }}
                                >
  You will receive order notifications via{' '} SMS

</span>

                                <div className="row">
                                    {/* Name Input */}
                                    {error && (<div
                                            style={{
                                                color: '#dc3545', // Bootstrap's red for errors
                                                fontSize: '0.85rem', // smaller text
                                                marginBottom: '0.5rem', fontWeight: '500',
                                            }}
                                            role="alert"
                                        >
                                            {error}
                                        </div>)}
                                    <div className="col-12 mb-2" ref={nameRef}>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            id="name"
                                            value={name}
                                            onChange={(e) => {
                                                setName(e.target.value);
                                                setError('');
                                                setErrorStatus(null);
                                            }}
                                            placeholder="Name"
                                            required
                                            maxLength={20}
                                            style={{
                                                borderRadius: '0.375rem',
                                                padding: '0.4rem 0.75rem',
                                                fontSize: '0.875rem',
                                                boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                                                borderColor: errorStatus === 1 || errorStatus === 2 ? 'red' : '#ced4da',
                                                transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
                                            }}
                                            onFocus={(e) => {
                                                e.target.style.borderColor = '#495057';
                                                e.target.style.boxShadow = '0 0 0 0.15rem rgba(73,80,87,.25)';
                                            }}
                                            onBlur={(e) => {
                                                e.target.style.borderColor = errorStatus === 1 || errorStatus === 2 ? 'red' : '#ced4da';
                                                e.target.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
                                            }}
                                        />
                                    </div>

                                    <div className="col-12 mb-2" ref={phoneRef}>
                                        <div className="input-group input-group-sm">
    <span
        className="input-group-text bg-white"
        style={{
            borderRadius: '0.375rem 0 0 0.375rem',
            display: 'flex',
            alignItems: 'center',
            padding: '0.375rem 0.5rem',
            gap: '4px',
        }}
    >
      <img
          src="https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg"
          alt="USA Flag"
          style={{
              width: '14px', height: '12px', objectFit: 'cover', borderRadius: '2px',
          }}
      />
      +1
    </span>
                                            <input
                                                type="tel"
                                                className="form-control form-control-sm"
                                                id="phone"
                                                value={formatPhoneNumber(phone)}
                                                onChange={handlePhoneChange}
                                                placeholder="(123) 456-7890"
                                                required
                                                maxLength={14}
                                                style={{
                                                    borderRadius: '0 0.375rem 0.375rem 0',
                                                    padding: '0.4rem 0.75rem',
                                                    fontSize: '0.875rem',
                                                    boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                                                    borderColor: errorStatus === 1 || errorStatus === 3 || errorStatus === 4 ? 'red' : '#ced4da',
                                                    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
                                                }}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#495057';
                                                    e.target.style.boxShadow = '0 0 0 0.15rem rgba(73,80,87,.25)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = errorStatus === 1 || errorStatus === 3 || errorStatus === 4 ? 'red' : '#ced4da';
                                                    e.target.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
                                                }}
                                            />
                                        </div>
                                    </div>


                                </div>

                                <div className=" tip-options">
                                    <div className='row'>
                                        <div className="col-12">
                                            {/* Loading Spinner */}
                                            {loading && (<div className="col-12 mb-3 text-center">
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>)}

                                            <RewardModal
                                                isOpen={isRewardModalOpen}
                                                onClose={() => setIsRewardModalOpen(false)}
                                                points={rewardPoints}
                                                phone={phone}
                                                handlePhoneChange={handlePhoneChange}
                                            />
                                        </div>

                                    </div>
                                    <div className='row'>
                                        <div className="col-12">
                                            {!loading && (<div className="col-12 ">
                                                    {phone.length !== 10 ? (<div className="alert alert-warning">
                                                            Enter phone number above to view your reward points.

                                                        </div>) : phone.length === 10 && !rewardPoints ? (
                                                        <div className="alert alert-warning">
                                                            No reward points yet. Start ordering with this number to
                                                            earn points!
                                                        </div>) : (<div className="alert alert-success">
                                                            You have <strong>{rewardPoints}</strong> reward points!
                                                        </div>)}
                                                </div>)}
                                        </div>
                                        <div style={{display: 'flex', justifyContent: 'center'}}>
                                            <button
                                                className="btn btn-primary"
                                                onClick={() => setIsRewardModalOpen(true)}
                                                style={{
                                                    width: '100%',
                                                    borderRadius: '50px',
                                                    textAlign: 'center',
                                                    fontWeight: '600',
                                                }}
                                            >
                                                See All Available Rewards
                                            </button>
                                        </div>

                                    </div>

                                </div>

                            </div>


                            <div className="section order-total">
                                <h5 className="fw-semibold fs-6 mb-3 border-bottom pb-2">
                                    Order total
                                </h5>

                                <div className="order-summary">
                                    <p className="fs-8 fw-bold text-black">
                                        Subtotal <span>{feeLoading ? <Skeleton width={60} height={20}
                                                                               duration={0.5}/> : `$${calculatedFees?.subtotal}`}</span>
                                    </p>

                                    <p className="fs-8 fw-bold text-black">
                                        Taxes <span>{feeLoading ? <Skeleton width={50} height={20}
                                                                            duration={0.5}/> : `$${calculatedFees?.tax}`}</span>
                                    </p>

                                    {feeLoading ? (<>
                                            {/* Always show skeleton for Processing Fee */}
                                            {+calculatedFees?.processingFee > 0 && (

                                                <p className="fs-8 fw-bold text-black d-flex justify-content-between align-items-center">
                                                    <Skeleton width={100} height={20} duration={0.5}/>
                                                    <Skeleton width={60} height={20} duration={0.5}/>
                                                </p>)}

                                            {/* Only show skeleton for Commission Fee if not delivery */}
                                            {!needDelivery && (
                                                <p className="fs-8 fw-bold text-black d-flex justify-content-between align-items-center">
                                                    <Skeleton width={100} height={20}
                                                              duration={0.5}/> {/* Skeleton for "Commission Fee" label */}
                                                    <Skeleton width={60} height={20}
                                                              duration={0.5}/> {/* Skeleton for Commission Fee value */}
                                                </p>)}
                                        </>) : (<>
                                            {+calculatedFees?.processingFee > 0 && (
                                                <p className="fs-8 fw-bold text-black d-flex justify-content-between">
                                                    <span>Processing</span>
                                                    <span>${calculatedFees.processingFee}</span>
                                                </p>)}
                                            {+calculatedFees?.commissionFee > 0 && (
                                                <p className="fs-8 fw-bold text-black d-flex justify-content-between">
                                                    <span>Service Fee</span>
                                                    <span>${calculatedFees.commissionFee}</span>
                                                </p>)}
                                        </>)}


                                    {checkCoupon && parseFloat(calculatedFees?.subtotal) >= parseFloat(checkCoupon.min_require) && (
                                        <p className="fs-8 fw-bold text-black">
                                            Discount <span>{feeLoading ? <Skeleton width={60} height={20}
                                                                                   duration={0.5}/> : `-$${calculatedFees?.discount}`}</span>
                                        </p>)}

                                    {orderMethod === 'delivery' && (<>
                                            {needDelivery && (
                                                <p className="fs-8 fw-bold text-black d-flex justify-content-between align-items-center">
                                                    {feeLoading ? (<>
                                                            <Skeleton width={100} height={20} duration={0.5}/>
                                                            <Skeleton width={60} height={20} duration={0.5}/>
                                                        </>) : (<>
                                                            <span>Service Fee</span>
                                                            <span>${calculatedFees?.serviceFee}</span>
                                                        </>)}
                                                </p>)}

                                            <p className="fs-8 fw-bold text-black d-flex justify-content-between align-items-center">
                                                {feeLoading ? (<>
                                                        <Skeleton width={110} height={20} duration={0.5}/>
                                                        {addressVerified ? (
                                                            <Skeleton width={60} height={20} duration={0.5}/>) : (
                                                            <Skeleton width={150} height={20} duration={0.5}/>)}
                                                    </>) : (<>
                                                        <span>Delivery Fee</span>
                                                        <span>
            {addressVerified ? (`$${calculatedFees.deliveryFee}`) : (<em
                    style={{
                        color: '#555', fontStyle: 'italic', display: 'inline-flex', alignItems: 'center', gap: '6px'
                    }}
                >
                    <svg
                        className="spinner"
                        width="16"
                        height="16"
                        viewBox="0 0 50 50"
                        style={{animation: 'spin 1s linear infinite'}}
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle
                            cx="25"
                            cy="25"
                            r="20"
                            fill="none"
                            stroke="#555"
                            strokeWidth="5"
                            strokeLinecap="round"
                            strokeDasharray="31.4 31.4"
                            strokeDashoffset="0"
                        />
                    </svg>
                    Waiting for address...
                </em>)}
          </span>
                                                    </>)}
                                            </p>
                                        </>)}


                                    <p className="fs-8 fw-bold text-black">
                                        Tip <span>{feeLoading ? <Skeleton width={50} height={20}
                                                                          duration={0.5}/> : `$${calculatedFees?.tip}`}</span>
                                    </p>

                                    <div className="w-100 mx-auto border rounded d-flex overflow-hidden bg-white"
                                         style={{maxWidth: '28rem'}}>
                                        {(needDelivery ? [15, 18, 20] : (fee?.tip_options?.length > 0 ? fee.tip_options : [10, 15, 18]))
                                            .slice()
                                            .sort((a, b) => a - b)
                                            .map((percent) => (<button
                                                    key={percent}
                                                    className={`flex-fill py-2 text-center fw-bold text-black small border-0 transition ${tip === +percent ? 'bg-red text-white' : 'bg-transparent'}`}
                                                    onClick={() => handleTipSelect(percent)}
                                                >
                                                    {percent}%
                                                </button>))}

                                        <button
                                            className={`flex-fill py-2 text-center fw-bold text-black small border-0 transition ${tip === 0 ? 'bg-red text-white' : 'bg-transparent'}`}
                                            onClick={handleCustomTip}
                                        >
                                            Custom
                                        </button>
                                    </div>


                                    <div
                                        style={{
                                            borderTop: '2px solid #dee2e6', paddingTop: '0.5rem', marginTop: '1rem',
                                        }}
                                    ></div>

                                    <p className="fs-5 fw-bold text-black">
                                        Total <span>{feeLoading ? <Skeleton width={80} height={30}
                                                                            duration={0.5}/> : `$${calculatedFees?.total}`}</span>
                                    </p>
                                </div>
                            </div>


                            {calculatedFees?.subtotal > 0 && (
                                <p className="text-info fw-semibold text-center mt-2 small">
                                    You will earn {(calculatedFees?.subtotal * 10).toFixed(2)} reward points this order
                                </p>)}

                            {/* Error messages styled with Bootstrap alerts */}
                            {!needAmountReached() && (<div className="alert alert-danger mb-2" role="alert">
                                    You need to reach the minimum amount to redeem the free item.
                                </div>)}

                            {orderMethod === 'delivery' && calculatedFees?.subtotal < (+fee?.min_delivery_amount || 20) && (
                                <div className="alert alert-danger mb-2" role="alert">
                                    Minimum order amount of ${fee?.min_delivery_amount || 20} in subtotal is required
                                    for delivery.
                                </div>)}

                            {orderMethod === 'delivery' && !addressVerified && (
                                <div className="alert alert-danger mb-2" role="alert">
                                    Please enter a valid address within {fee?.max_delivery_range || 5} miles of the
                                    restaurant.
                                </div>)}


                            <button
                                className="process-payment btn-primary fw-bold w-100 p-4 d-flex justify-content-center align-items-center"
                                style={{fontSize: '18px', position: 'relative'}}
                                disabled={(orderMethod === 'delivery' && !addressVerified) || !needAmountReached() || feeLoading}
                                onClick={handlePlaceOrder}
                            >
  <span style={{minHeight: '1.5em', display: 'flex', alignItems: 'center', color: 'white'}}>
    {feeLoading ? (<>
        <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
        ></span>
            Loading...
        </>) : (<div className='flex items-center gap-2 text-white font-semibold text-base'>
            Proceed to Payment
            <FaLongArrowAltRight className="text-lg"/></div>)}
  </span>
                            </button>

                        </Col>
                    </Row>
                    <EditCartModal modal={editCartModal} item={selectedItem} setModal={setEditCartModal}/>
                    <EditFreeItemModal modal={editFreeItem} item={selectedItem} setModal={setEditFreeItem}/>
                    <EditRewardItemModal modal={editRewardItem} item={selectedItem} setModal={setEditRewardItem}/>
                    <Modal show={showTipModal} onHide={() => setShowTipModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Enter Custom Tip</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group className="d-flex align-items-center justify-content-center">
                                <button className="btn btn-primary " onClick={decrementTip}>
                                    <FontAwesomeIcon icon={faChevronDown}/>
                                </button>
                                <Form.Control
                                    type="tel"
                                    min="0"
                                    value={customTip}
                                    onChange={handleCustomTipChange}
                                    placeholder="Enter custom tip amount"
                                    className="mx-2 text-center"
                                    style={{maxWidth: '100px'}}
                                />
                                <button className="btn btn-primary " onClick={incrementTip}>
                                    <FontAwesomeIcon icon={faChevronUp}/>
                                </button>
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="w-100 btn btn-primary" onClick={() => {
                                setAcutalTip(customTip)
                                setShowTipModal(false)
                            }}>Save
                            </button>
                        </Modal.Footer>
                    </Modal>

                    <Modal
                        show={showPaymentModal}
                        onHide={handleModalClose}
                        backdropClassName="overlay"
                        centered
                        size="lg"
                    >


                        <>
                            <Modal.Header closeButton>
                                <Modal.Title>Payment Method</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {paymentSubmitLoading ? (<Lottie
                                        loop
                                        animationData={loadingJson}
                                        play
                                    />) : (<>
                                        <div className="d-flex">
                                            {needDelivery ? (<>

                                                    <div className="d-flex w-100 mb-3">
                                                        <button
                                                            className={`payment-button w-100 ${paymentOption === 'online' ? 'primary' : ''}`}
                                                            onClick={() => handlePaymentMethodChange('online')}
                                                            type="button"
                                                        >
                                                            Online
                                                        </button>

                                                    </div>
                                                </>) : (<div className="d-flex w-100 mb-3">
                                                    <button
                                                        className={`payment-button w-100 ${paymentOption === 'online' ? 'primary' : ''}`}
                                                        onClick={() => handlePaymentMethodChange('online')}
                                                        type="button"
                                                    >
                                                        Online
                                                    </button>

                                                </div>


                                            )}

                                        </div>

                                        {paymentOption === 'online' && (<>
                                                <CheckoutApp
                                                    tip={tip}
                                                    restaurantId={restaurantId}
                                                    name={name}
                                                    phone={phone}
                                                    cartItems={cart}
                                                    coupon={checkCoupon}
                                                    address={needDelivery ? currentUserAddress : 'Pickup'}
                                                    selectedTime={selectedTime ? selectedTime : 'ASAP'}
                                                    freeItem={freeItem?.Item ? freeItem : null}
                                                    rewardItem={rewardItem?.Item ? rewardItem : null}
                                                    email={email}
                                                    aptNumber={aptNumber}
                                                    deliveryInstructions={deliveryInstructions}
                                                    customTip={acutalTip}
                                                />

                                            </>)}

                                        {paymentOption === 'in-store' && (<>
                                                <button className="black-button  p-3 mt-3" onClick={handlePayInStore}
                                                        disabled={payinStoreLoading}>
                                                    {payinStoreLoading ? (<span
                                                            className="spinner-border spinner-border-sm"></span>) : ('Place Order (Pay In Store)')}
                                                </button>
                                            </>)}


                                    </>)}
                            </Modal.Body>

                        </>
                    </Modal>


                    <Modal show={timeModal} onHide={() => setTimeModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Schedule Time for {todayLabel}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                <Form.Group>
                                    <Form.Label>Select a {needDelivery ? 'delivery' : 'pickup'} time</Form.Label>
                                    <div
                                        className="d-flex flex-column"
                                        style={{
                                            maxHeight: '60vh',
                                            overflowY: 'auto',
                                            padding: '10px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            backgroundColor: '#f9f9f9',
                                            WebkitOverflowScrolling: 'touch',
                                        }}
                                    >
                                        {timeSlots.length > 0 ? (timeSlots.map((slot, index) => (<span
                                                    key={index}
                                                    className={`time-slot mb-2 p-2 ${selectedTime === slot ? 'selected-time-slot' : ''}`}
                                                    onClick={() => handleTimeSelect(slot)}
                                                    style={{
                                                        cursor: 'pointer',
                                                        border: '2px solid grey',
                                                        borderRadius: '4px',
                                                        fontSize: '1.1rem',
                                                        borderColor: selectedTime === slot ? 'var(--primary-color)' : '#fff',
                                                        transition: 'background-color 0.3s ease, color 0.3s ease',
                                                    }}
                                                >
                {slot}
              </span>))) : (<div>No available time slots</div>)}
                                    </div>
                                </Form.Group>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                className='w-100 btn-primary'
                                onClick={() => setTimeModal(false)}
                            >
                                Confirm
                            </button>
                        </Modal.Footer>
                    </Modal>


                </Container>
            </div>
        </>);
};

export default Checkout;
